import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { FieldWrap } from "@/components/Field";
import { useApp } from "@/context/AppContext";
import { api, errMsg } from "@/lib/api";

export default function ForcePassword() {
  const { user, refreshMe, logout } = useApp();
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    if (f.next.length < 6) { toast.error("New password must be at least 6 characters", { id: "pw" }); return; }
    if (f.next !== f.confirm) { toast.error("The two new passwords do not match", { id: "pw" }); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      toast.success("Password changed. Welcome!");
      await refreshMe();
    } catch (err) { toast.error(errMsg(err), { id: "pw" }); } finally { setBusy(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6 py-12">
      <form onSubmit={save} className="w-full max-w-md space-y-5 rounded-2xl bg-white p-8 shadow-xl" data-testid="force-password-form">
        <div className="flex items-center gap-3">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[hsl(var(--primary))] text-white"><KeyRound className="h-5 w-5" /></span>
          <div>
            <h1 className="font-heading text-2xl font-bold text-slate-900">Choose your own password</h1>
            <p className="text-sm text-slate-600">Hi {user.name}, please replace the temporary password the Master Admin gave you.</p>
          </div>
        </div>
        <FieldWrap label="Temporary (current) password"><Input type="password" className="h-12" value={f.current} onChange={set("current")} autoComplete="current-password" data-testid="force-current-password" /></FieldWrap>
        <FieldWrap label="New password (6+ characters)"><Input type="password" className="h-12" value={f.next} onChange={set("next")} autoComplete="new-password" data-testid="force-new-password" /></FieldWrap>
        <FieldWrap label="Type new password again"><Input type="password" className="h-12" value={f.confirm} onChange={set("confirm")} autoComplete="new-password" data-testid="force-confirm-password" /></FieldWrap>
        <Button type="submit" disabled={busy} className="h-12 w-full text-base" data-testid="force-password-submit">
          {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Save my new password
        </Button>
        <button type="button" onClick={logout} className="w-full text-center text-sm text-slate-500 underline" data-testid="force-password-logout">Log out</button>
      </form>
    </div>
  );
}
